import React, { Component } from 'react';
import "./careers.css"
class Career extends Component {
       
    constructor(props) {
        super(props);
        
        this.state = {
       
          noerorrpage :  true
        };
        
    
      }
    componentWillMount(){
        this.props.noerorrpage(this.state.noerorrpage)
    }
  render() {
    // var divStyle = {
    //     color: 'white',
    //     background: "red",
    //     height:"auto",
    //     WebkitTransition: 'all', // note the capital 'W' here
    //     "margin-top":"110px"
        
    //   };
    return (
            <div className="Home"> 
                 <div className="carres-page-Hard">
                        <div className="carres-hero-image">
                            <div className="carres-hero-text">
                            
                            <h1 className="carres-page-head-h1">Join us. From anywhere.</h1>
                                <h3 className="carres-page-head-h3">Want to help everyone become more productive at work? We’re hiring.</h3>
                                
                         </div>
                     </div>
                 </div>  
                 <div className="carres-page-Style-body">
                   <div className="carres-page-Style-sub">
                     <h1 className="carres-page-Style-h1">Our Style of Work</h1>
                      <div className="columns">
                          <div className="column is-half">
                            <p className="carres-page-Style-para"><b>Freedom and flexibility . </b>  All 30-plus of us work wherever we’d like—reliable internet access is our
                             only requirement. Spread across 5 time zones in 3 countries, we sign into 
                             Slack and open up our work tools on the schedule that 
                            fits our lives best. We communicate asynchronously, work autonomously, and take ownership of our work.
                            </p> 
                            <p className="carres-page-Style-para"><b> Camaraderie from afar . </b>  All 30-plus of us work wherever we’d like—reliable internet access is our
                             only requirement. Spread across 5 time zones in 3 countries, we sign into 
                             Slack and open up our work tools on the schedule that 
                            fits our lives best. We communicate asynchronously, work autonomously,
                             and take ownership of our work.100% distributed doesn’t hold us back
                              from getting to know each other—daily conversation in chat includes 
                              non-work topics like #cooking and #scifi, weekly posts to our company
                               blog show off pictures of pets and hobbies, and twice-annually we all
                             come together for an all-team retreat that includes an adventure day.
                            </p> 
                          </div>
                          <div className="column">
                            <p className="carres-page-Style-para"><b>Learning on- and offline . </b>
                             You start your role by meeting up in person with 
                             your manager for an onboarding week. Then you learn the
                              product thoroughly by pairing up with a support team member.
                               And the learning doesn’t stop there—ongoing feedback from 
                               your manager and peers is one of our five team values, 
                               and we support your professional development.
                            </p> 
                            <p className="carres-page-Style-para"><b>LSolve interesting problems . </b>
                            Our product integrates 1,000+ online tools to make it easy for schools
                             to connect and get more work done. Supporting and evolving our product 
                             is no easy task itself, though. Our "build the robot" value yields 
                             outsized impacts and our all-hands support approach brings everyone to the table.
                            </p> 
                          </div>
                       
                      </div>
                   </div>
                 </div> 

                 <div className="carres-page-image-body">
                     <div className="carres-page-image-sub">

                        <div className="columns">
                                <div className="column is-half">
                                  <div className="carres-page-image-style">
                                       <img src="https://fabwoman.ng/wp-content/uploads/2018/01/Working-together.jpg"  />
                                  </div>
                                   
                                </div>
                                <div className="column">
                                     <div className="carres-page-image-style">
                                       <img src="https://storage.googleapis.com/igeeksblog/wp-content/uploads/2017/05/How-to-Cancel-Google-Play-Music-Subscription.jpg"/>
                                     </div>
                                </div>
                                
                        </div>
                        <div className="carres-page-image">
                         
                            <div class="columns">
                                <div class="column is-two-fifths">
                                    <div className="carres-page-image-style">
                                   <img src="https://www.lifewire.com/thmb/gbg88BhbrckpCdLCwiVgtKJSt-w=/768x0/filters:no_upscale():max_bytes(150000):strip_icc()/463245195-56a289685f9b58b7d0cbe437.jpg"/>
                                  </div>
                                </div>
                                <div class="column">
                                    <div className="carres-page-image-style">
                                         <img src="https://static1.squarespace.com/static/58c45bcc59cc687d85238540/t/58c5c34ea5790aa56a9783a5/1489355769102/black+business+owner+3.jpg?format=2500w" />
                                    </div>
                                </div>
                             
                            </div>
                        </div>
                    </div>

                 </div>
                 <div className="carres-page-image-article-body">
                       <div className="carres-page-image-aricle-sub">
                           <div class="columns">
                                <div class="column is-half">
                                   <h1 className="carres-page-image-aricle-para"> How We Hire</h1>
                                   <p>
                                   We have a non-standard application process. To jump-start the process, we ask applicants to answer a few questions in an online form that we normally would ask at the start of an interview. This helps speed up the process and lets us get to know you a bit better right out of the gate.

To avoid bias, we use custom-built extensions for our hiring tools that mask candidates' names and photos, as well as comments from other application reviewers on the hiring team.

The hiring team reviews candidates’ applications based on a rubric for the job requirements. To proceed to the hiring stage, candidates will typically participate in two interviews via video chat, as well as a skills test based on the role.

You’ll hear from us throughout the application process. We have made a commitment to applicants that we will be in touch with them at least once per week while they are going through the hiring process.
                                   </p>
                                </div>
                                <div class="column">
                                   <img src="https://c.slashgear.com/wp-content/uploads/2015/11/apple-magic-keyboard-mouse-2-trackpad-2-review-2-1280x720.jpg" />
                                </div>
                             
                            </div>    
                       </div>
                 </div>

                       
        <footer className="footer">
          
          <div className="search-footer-body-full">
            <div className="columns">
              <div className="column ">
                 <div className="search-footer-body">
                    <h5 className="search-footer-Menu-Title">Uvune</h5>
                    <br/>
                    <ul className="search-footer-Menu-list" >
                      <li>About</li>
                      <li>Careers</li>
                      {/* <li>Contact</li> */}
                      <li>Terms of Use</li>
                      {/* <li>Privacy Policy</li>
                      <li>Security Policy</li> */}
                    </ul>  
                 </div>
              </div>
              <div className="column">
                 <h5 className="search-footer-Menu-Title">Solutions</h5>
                    <br/>
                    <ul className="search-footer-Menu-list" >
                      <li>Education</li>
                      {/* <li>Healthcare</li>
                      <li>Business</li>
                      <li>Platform</li> */}
                    
                    </ul> 
              </div>
              <div className="column">
                 <h5 className="search-footer-Menu-Title">Community</h5>
                    <br/>
                  <ul className="search-footer-Menu-list" >
                      <li>Blog & News</li>
                      {/* <li>Engineering</li> */}
                      <li>Twitter</li>
                      <li>Facebook</li>
                      {/* <li>Linkedin</li> */}
                      
                  </ul> 
              </div>
              <div className="column">
                  <h5 className="search-footer-Menu-Title"></h5>
                    <br/>
                  <ul className="search-footer-Menu-list" >
                      <li>
                        <img width="50" src="http://res.cloudinary.com/easywaya/image/upload/v1535530819/uvunelogo2_ayfgrq.png"/>
                      </li>
                      <li>
                        <img width="50" src="https://res.cloudinary.com/easywaya/image/upload/v1524426443/12829476_1065330896870118_4143080475571245991_o_qh9gzs.jpg"/>
                      </li>  
                  </ul> 
              </div>
            </div>
           
          </div>
          
     
    </footer>
    <div className="search-footer-body-sub">
              Copyright ©Uvune. 2009-2018 All rights reserved. Uvune is a trademark of Uvune Corporation.
    </div>

       
           </div>     

    )

}





}

export default Career;


// WEBPACK FOOTER //
// ./src/component/page/careers.js